import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import type { UnifiedEvent } from 'src/app/analytics/analyticsEvents';
import { checkProviderZipCode } from 'src/app/router/paths';
import { segmentTrack } from 'src/app/state/actions';
import { getCurrentPathParams, shouldShowFaqModal } from 'src/app/state/selectors';
import type { Dispatch, RootState } from 'src/app/state/store';
import { arePathnamesEqual, getLocationParams, standardizePathName } from 'src/app/utils';

import { PARTNER_ZIP_CHECK } from './constants';

import ZipCodeCheckPageComponent from '.';

const mapStateToProps = (state: RootState) => {
  const pathname = standardizePathName(state.router.location.pathname);
  const pathParams = getLocationParams(getCurrentPathParams(state));
  const partner = pathParams['r'];
  const isProvider = arePathnamesEqual(pathname, checkProviderZipCode.toPath());
  const isAllina = partner?.toLowerCase() === 'allina';

  return {
    showFaqModal: shouldShowFaqModal(state),
    partner: pathParams['r'],
    partnerContent: PARTNER_ZIP_CHECK[partner?.toLowerCase()],
    isProvider,
    isAllina,
    showHeartSVG: !isAllina,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  dispatchSegmentTrack: (event: UnifiedEvent, payload: { [key: string]: string }) =>
    dispatch(segmentTrack(event, payload)),
});
const connector = connect(mapStateToProps, mapDispatchToProps);

export type PropsFromRedux = ConnectedProps<typeof connector>;

export const ZipCodeCheckPage = withRouter(connector(ZipCodeCheckPageComponent));
